import React from "react";
import { login } from "../../api/auth";

export default function LoginForm({ onClose, onSuccess, variant = "modal" }) {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login({ email, password });
      if (onSuccess) onSuccess();
      if (onClose) onClose();
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const formClass = [
    "form-vert-stack",
    variant === "page" ? "login-form--page" : "",
  ].filter(Boolean).join(" ");

  return (
    <form onSubmit={onSubmit} className={formClass}>
      {error && <div className="form-error">{error}</div>}

      <div className="form-group">
        <label className="form-label">Email</label>
        <input
          className="form-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoFocus
          autoComplete="email"
        />
      </div>

      <div className="form-group">
        <label className="form-label">Password</label>
        <input
          className="form-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
        />
      </div>

      <div className="form-actions">
        <button type="submit" disabled={loading} className="btn btn-primary">
          {loading ? "Signing in..." : "Sign In"}
        </button>
        {onClose && variant !== "page" && (
          <button type="button" onClick={onClose} className="btn btn-link">
            Cancel
          </button>
        )}
      </div>
    </form>
  );
}
